<template>
  <InfoElevePanierPrincipal />
</template>

<script>
import useAppStore from '@/store/appStore';
import usePanierStore from '@/store/panierStore';
import InfoElevePanierPrincipal from '../components/Panier/InfoElevePanierPrincipal.vue';

export default {
  name: 'InfoElevePanierView',
  components: {
    InfoElevePanierPrincipal,
  },
  setup() {
    const appStore = useAppStore();
    const panierStore = usePanierStore();

    return { appStore, panierStore };
  },
  computed: {

  },
  created() {
    if (this.panierStore.listeCoursPanier.length === 0) {
      window.location.href = `${this.appStore.modele.urlBase}/#/Boutique`;
    }
  },
};
</script>
